(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sectionId = '{{ section.id }}';
    const wrapper = document.getElementById(`testimonials-wrapper-${sectionId}`);
    const track = document.getElementById(`testimonials-track-${sectionId}`);
    const paginationContainer = document.getElementById(`testimonials-pagination-${sectionId}`);
    
    if (!track || !wrapper || !paginationContainer) return;

    const items = track.querySelectorAll('.testimonials-slider-item');

    if (items.length === 0) return;

    let currentIndex = 0;
    let itemWidth = 0;
    let gap = 0;
    let visibleItems = 0;
    let maxIndex = 0;
    let touchStartX = 0;
    let touchEndX = 0;
    let dots = [];

    // Calculate responsive values
    function calculateDimensions() {
      itemWidth = items[0].offsetWidth;
      
      // Get computed gap
      const trackStyle = window.getComputedStyle(track);
      gap = parseInt(trackStyle.gap) || 20;

      // Determine visible items based on viewport
      if (window.innerWidth > 1024) {
        visibleItems = 3;
      } else if (window.innerWidth > 640) {
        visibleItems = 2;
      } else {
        visibleItems = 1;
      }

      // Calculate max index (scroll positions available)
      maxIndex = Math.max(0, items.length - visibleItems);
      
      // Recreate dots based on scroll positions
      createDots();
    }

    // Create dots dynamically based on available positions
    function createDots() {
      paginationContainer.innerHTML = '';
      dots = [];

      // Only show dots if there's more than one position to scroll to
      if (maxIndex > 0) {
        for (let i = 0; i <= maxIndex; i++) {
          const dot = document.createElement('button');
          dot.className = `testimonials-dot ${i === currentIndex ? 'active' : ''}`;
          dot.setAttribute('data-position', i);
          dot.setAttribute('aria-label', `Go to position ${i + 1}`);
          dot.setAttribute('aria-current', i === currentIndex ? 'true' : 'false');
          
          dot.addEventListener('click', () => goToSlide(i));
          
          paginationContainer.appendChild(dot);
          dots.push(dot);
        }
      }
    }

    // Update card scales
    function updateCardScales() {
      const cards = track.querySelectorAll('.testimonials-card');
      cards.forEach((card, index) => {
        let isCenterCard = false;
        
        if (visibleItems === 3) {
          isCenterCard = index === currentIndex + 1;
        } else if (visibleItems === 2) {
          isCenterCard = index === currentIndex + 1;
        } else {
          isCenterCard = index === currentIndex;
        }

        card.classList.toggle('active', isCenterCard);
        card.classList.toggle('inactive', !isCenterCard && (index >= currentIndex && index < currentIndex + visibleItems));
      });
    }

    // Update slider position and dots
    function updateSlider() {
      const offset = currentIndex * (itemWidth + gap);
      track.style.transform = `translateX(-${offset}px)`;

      // Update all dots
      dots.forEach((dot, index) => {
        const isActive = index === currentIndex;
        dot.classList.toggle('active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      updateCardScales();
    }

    // Go to specific position
    function goToSlide(index) {
      currentIndex = Math.max(0, Math.min(index, maxIndex));
      updateSlider();
    }

    // Next position
    function nextSlide() {
      if (currentIndex < maxIndex) {
        goToSlide(currentIndex + 1);
      } else if (currentIndex === maxIndex && maxIndex > 0) {
        // Loop back to start if we have pagination
        goToSlide(0);
      }
    }

    // Previous position
    function prevSlide() {
      if (currentIndex > 0) {
        goToSlide(currentIndex - 1);
      } else if (currentIndex === 0 && maxIndex > 0) {
        // Loop to end if we have pagination
        goToSlide(maxIndex);
      }
    }

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') prevSlide();
      if (e.key === 'ArrowRight') nextSlide();
    });

    // Touch/swipe support
    track.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, false);

    track.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, false);

    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          nextSlide(); // Swiped left
        } else {
          prevSlide(); // Swiped right
        }
      }
    }

    // Mouse wheel / scroll wheel support
    track.addEventListener('wheel', (e) => {
      if (maxIndex > 0) {
        e.preventDefault();
        if (e.deltaX > 0 || e.deltaY > 0) {
          nextSlide();
        } else if (e.deltaX < 0 || e.deltaY < 0) {
          prevSlide();
        }
      }
    }, { passive: false });

    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        calculateDimensions();
        // Clamp current index to new max
        if (currentIndex > maxIndex) {
          currentIndex = maxIndex;
        }
        updateSlider();
      }, 150);
    });

    // Initialize
    calculateDimensions();
    updateSlider();
  })();

  } catch(e) { console.error(e); }
})();
})();
